import React from 'react';
import MainView from 'routes/Main/Main.view';
import { useMainState } from './Main.state';

const Main: React.FC<{}> = () => {
    const state = useMainState();

    return (
        <>
            {state.currentRoomId && state.currentAreaId && (
                <MainView
                    {...{
                        ...state
                    }}
                />
            )}
        </>
    );
};

export default Main;
